import { range } from 'd3-array'

/*
 * Splits a bezier curve using de casteljau's algorithm.
 * The incoming points make up the bezier curve and should be 2-dimensional
 * (i.e. [x, y]) vectors.
 * By default splits the curve at 50%, so equal portions.
 *
 * Returns a two dimensional array containing the two partial curves.
 *
 * This was originally coded using the SVG api `getPathAtPoint` but
 * that ends up being ~1000x slower than usually d3 casteljau's algorithm
 */
export default function (points, t0 = .5) {
  let totalPoints = points.length -1
    , coefficients = points.map(point => [point]) // coefficients initialized to points
    , partial0 = [] // first curve
    , partial1 = [] // second curve
    , t1 = 1 - t0

  // multiply a point with some scalar factor
  let multiply = (point, factor) => {
    return point.map(coord => coord * factor)
  }

  // add points as vectors
  let add = (point0, point1) => {
    return range(Math.min(point0.length, point1.length)).map((coord, i) => {
      return point0[i] + point1[i]
    })
  }

  // Get all the coefficients
  for (let j = 1; j <= totalPoints; j++) {
    for (let i = 0; i <= (totalPoints - j); i++) {
      let scaled0 = multiply(coefficients[i][j - 1], t1)
        , scaled1 = multiply(coefficients[i + 1][j - 1], t0)
      coefficients[i].push(add(scaled0, scaled1))
    }
  }
  // Populate results
  points.forEach((point, i) => {
    partial0.push(coefficients[0][i])
    partial1.push(coefficients[i][totalPoints - i])
  })

  return [partial0, partial1]
}
